import { css } from 'styled-components';

import { BUTTON__CONTENT_CLASS } from '../constants';

export const iconButton = css`
  cursor: inherit;
  padding: 0;
  border: none;
  background: none;
  color: black;
  border-radius: 0;

  &:hover {
    .${BUTTON__CONTENT_CLASS} {
      color: inherit;
    }
  }

  .${BUTTON__CONTENT_CLASS} {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &::after {
      display: none;
    }
  }

  &[data-variant='leading'] {
    .${BUTTON__CONTENT_CLASS} {
      flex-direction: row-reverse;
    }
  }
`;
